import React from 'react'

const LightModeIconInactive = ({ width, height }: { width?: number; height?: number }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width || 14} height={height || 14} viewBox="0 0 14 14">
      <g fill="none" fillRule="evenodd">
        <g fill="#859AA5" fillRule="nonzero">
          <g>
            <g>
              <g>
                <g>
                  <g>
                    <path
                      d="M7 12.065c.35 0 .63.28.63.63v.611c0 .35-.28.63-.63.63h-.006c-.35 0-.63-.28-.63-.63v-.61c0-.35.28-.63.63-.63H7zm4.677-1.31l.248.248c.249.248.249.649 0 .897-.248.248-.649.248-.897 0l-.248-.248c-.248-.248-.248-.643.006-.897.242-.242.643-.249.891 0zm-8.47-.007l.007.007c.241.241.248.642 0 .89l-.249.249c-.248.248-.649.248-.897 0-.248-.249-.248-.643-.006-.898l.248-.248c.248-.248.65-.248.897 0zM7 3.15c2.106 0 3.818 1.712 3.818 3.818 0 2.107-1.712 3.818-3.818 3.818S3.182 9.075 3.182 6.968C3.182 4.862 4.894 3.15 7 3.15zm0 1.305c-1.406 0-2.545 1.14-2.545 2.545 0 1.406 1.14 2.545 2.545 2.545 1.406 0 2.545-1.14 2.545-2.545 0-1.406-1.14-2.545-2.545-2.545zM1.28 6.332c.35 0 .63.28.63.636v.007c0 .35-.28.63-.637.623H.63c-.35 0-.63-.28-.63-.63v-.006c0-.35.28-.63.63-.63h.65zm12.084 0c.35 0 .63.28.63.63v.006c0 .35-.28.63-.63.63h-.643c-.35 0-.63-.28-.63-.63v-.006c0-.35.28-.63.63-.63h.643zM2.965 2.036l.249.249c.248.241.248.649 0 .89l-.007.007c-.248.248-.642.248-.89 0l-.249-.248c-.248-.242-.248-.643 0-.891l.007-.007c.241-.241.642-.248.89 0zm8.967.007c.248.248.248.642 0 .89l-.248.249c-.242.248-.643.248-.891 0l-.007-.007c-.248-.241-.248-.642 0-.89l.249-.249c.248-.241.649-.241.897.007zM7.006 0c.35 0 .63.28.63.63v.617c0 .35-.28.63-.636.624h-.006c-.35 0-.63-.28-.63-.63V.63c0-.35.28-.63.636-.63h.006z"
                      transform="translate(-29 -740) translate(19 734) translate(10 6)"
                    />
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  )
}

export default LightModeIconInactive
